import React, { memo } from 'react';
import { useSpring, animated } from 'react-spring';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import { makeStyles } from '@material-ui/core/styles';
import MaterialModal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';

const useStyles = makeStyles((theme) => ({
  modal: {
    overflow: 'scroll',
    padding: '20px',
    display: 'flex',
    minHeight: '100vh',
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      padding: '50px',
    },
  },
  inner: {
    margin: 'auto',
    maxWidth: '700px',
    width: '100%',
    overflow: 'visible',
  },
  large: {
    margin: 'auto',
    maxWidth: '750px',
    maxHeight: '540px',
    width: '100%',
    overflow: 'visiible',
  },
  narrow: {
    maxWidth: '500px',
  },
  medium: {
    maxWidth: '600px',
  },
}));

const Modal = ({ children, open, handleClose, narrow, large, medium }) => {
  const classes = useStyles();

  const style = useSpring({
    opacity: open ? 1 : 0,
    transform: open ? 'translate(0, 0)' : 'translate(0, 50px)',
  });

  const backdropStyle = useSpring({
    opacity: open ? 1 : 0,
  });

  const renderBackdrop = () => (
    <animated.div style={backdropStyle}>
      <Backdrop open transitionDuration={0} onClick={handleClose} />
    </animated.div>
  );

  return (
    <MaterialModal
      open={open}
      onClose={handleClose}
      className={classes.modal}
      BackdropComponent={renderBackdrop}
    >
      <animated.div
        className={clsx(classes.inner, {
          [classes.narrow]: narrow,
          [classes.large]: large,
          [classes.medium]: medium,
        })}
        style={style}
      >
        {children}
      </animated.div>
    </MaterialModal>
  );
};

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  open: PropTypes.bool.isRequired,
  narrow: PropTypes.bool,
  handleClose: PropTypes.func.isRequired,
  large: PropTypes.bool,
  medium: PropTypes.bool,
};

Modal.defaultProps = {
  narrow: false,
  large: false,
  medium: false,
};

export default memo(Modal);
